var _a, _b, _c, _d;
import createTheme from '@material-ui/core/styles/createTheme';
import defaultTheme from '@material-ui/core/styles/defaultTheme';
import { alpha } from '@material-ui/core/styles/colorManipulator';
var root = document.querySelector(':root');
var rootStyles = root ? getComputedStyle(root) : null;
var fonts = rootStyles === null || rootStyles === void 0 ? void 0 : rootStyles.getPropertyValue('--font-family-list');
var isGagra = __COMMON_UI_TYPE__ === 'gagra';
var primaryColor = ((_a = rootStyles === null || rootStyles === void 0 ? void 0 : rootStyles.getPropertyValue('--color-primary')) === null || _a === void 0 ? void 0 : _a.trim()) || '#f15623';
export default createTheme({
    typography: {
        fontFamily: fonts !== null && fonts !== void 0 ? fonts : [
            'OpenSans',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif'
        ].join(','),
        h6: { fontWeight: 600 },
        overline: { lineHeight: 1.175 },
        subtitle1: { lineHeight: 1.5 }
    },
    palette: {
        primary: {
            main: primaryColor,
            contrastText: ((_b = rootStyles === null || rootStyles === void 0 ? void 0 : rootStyles.getPropertyValue('--color-on-primary')) === null || _b === void 0 ? void 0 : _b.trim()) || '#fff'
        },
        secondary: {
            main: ((_c = rootStyles === null || rootStyles === void 0 ? void 0 : rootStyles.getPropertyValue('--color-secondary')) === null || _c === void 0 ? void 0 : _c.trim()) || '#375b7d',
            contrastText: ((_d = rootStyles === null || rootStyles === void 0 ? void 0 : rootStyles.getPropertyValue('--color-on-secondary')) === null || _d === void 0 ? void 0 : _d.trim()) || '#fff'
        },
        //primary: { main: '#f15623' },
        //secondary: { main: '#375b7d' },
        getContrastText: function (background) {
            var _a, _b, _c, _d, _e;
            if (background == ((_a = rootStyles === null || rootStyles === void 0 ? void 0 : rootStyles.getPropertyValue('--color-primary')) === null || _a === void 0 ? void 0 : _a.trim()))
                return (_b = rootStyles === null || rootStyles === void 0 ? void 0 : rootStyles.getPropertyValue('--color-on-primary')) === null || _b === void 0 ? void 0 : _b.trim();
            if (background == ((_c = rootStyles === null || rootStyles === void 0 ? void 0 : rootStyles.getPropertyValue('--color-secondary')) === null || _c === void 0 ? void 0 : _c.trim()))
                return (_d = rootStyles === null || rootStyles === void 0 ? void 0 : rootStyles.getPropertyValue('--color-on-secondary')) === null || _d === void 0 ? void 0 : _d.trim();
            if (typeof ((_e = defaultTheme === null || defaultTheme === void 0 ? void 0 : defaultTheme.palette) === null || _e === void 0 ? void 0 : _e.getContrastText) == 'function')
                return defaultTheme.palette.getContrastText(background);
            return '#fff';
        }
    },
    props: isGagra
        ? {
            MuiSwitch: {
                color: 'primary',
            },
            MuiCheckbox: {
                color: 'primary',
            },
        }
        : undefined,
    // Gagra's secondary color is a pale surface; use primary for foreground controls.
    overrides: isGagra ? {
        MuiButton: {
            textSecondary: {
                color: primaryColor,
                '&:hover': { backgroundColor: alpha(primaryColor, .04) },
            },
            outlinedSecondary: {
                color: primaryColor,
                borderColor: alpha(primaryColor, .5),
                '&:hover': {
                    borderColor: primaryColor,
                    backgroundColor: alpha(primaryColor, .04),
                },
            },
        },
        MuiTypography: {
            colorSecondary: { color: primaryColor },
        },
        MuiIconButton: {
            colorSecondary: {
                color: primaryColor,
                '&:hover': { backgroundColor: alpha(primaryColor, .04) },
            },
        },
    } : undefined,
    breakpoints: isGagra
        ? {
            values: {
                xs: 0,
                sm: 600,
                md: 960,
                lg: 1440,
                xl: 1920
            }
        } : undefined,
});
export const isGagraUI = isGagra;
